var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMyEventNewTag = function SvgMyEventNewTag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 50,
    fill: "none",
    viewBox: "0 0 95 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M15 0C6.716 0 0 6.716 0 15v34.351l17.872-7.707H80c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15H15Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.798 13.41v14.28h2.94v-9.56h.04l5.94 9.56h3.14V13.41h-2.94v9.58h-.04l-5.96-9.58h-3.12Zm21.484 8h-4.62c.014-.2.053-.426.12-.68.08-.252.207-.492.38-.72a2.18 2.18 0 0 1 .72-.56c.307-.16.687-.24 1.14-.24.694 0 1.207.188 1.54.56.347.374.587.92.72 1.64Zm-4.62 1.8h7.46a7.3 7.3 0 0 0-.2-2.3 5.532 5.532 0 0 0-.92-1.96 4.409 4.409 0 0 0-1.6-1.36c-.653-.346-1.42-.52-2.3-.52-.786 0-1.506.14-2.16.42-.64.28-1.193.668-1.66 1.16a4.962 4.962 0 0 0-1.08 1.72 6.032 6.032 0 0 0-.38 2.16c0 .8.12 1.534.36 2.2.253.668.607 1.24 1.06 1.72.454.48 1.007.854 1.66 1.12.654.254 1.387.38 2.2.38 1.174 0 2.174-.266 3-.8.827-.532 1.44-1.42 1.84-2.66h-2.5c-.093.32-.346.628-.76.92-.413.28-.907.42-1.48.42-.8 0-1.413-.206-1.84-.62-.427-.412-.66-1.08-.7-2Zm20.965 4.48 3.26-10.34h-2.92l-1.9 7h-.04l-1.76-7h-2.76l-1.72 7.02h-.04l-1.9-7.02h-3l3.28 10.34h2.94l1.76-6.94h.04l1.84 6.94h2.92Zm4.609-3.08v3.08h3.14v-3.08h-3.14Zm3.04-7.36v-3.84h-2.96v3.84l.76 6.16h1.42l.78-6.16Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 95,
    y1: 22.765,
    y2: 22.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C65"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMyEventNewTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/myEventNewTag.54efbec9e83871ee62733ff0c8e2281f.svg";